import StateChip from "../../_common/components/StateChip/index";
import TableBody from "../../_common/components/Table/TableBody";
import TableCell from "../../_common/components/Table/TableCell";
import TableContainer from "../../_common/components/Table/TableContainer";
import TableHead from "../../_common/components/Table/TableHead";
import TableRow from "../../_common/components/Table/TableRow";
import { h, Fragment } from "preact";
import { isMobileAgent } from "../../_common/common";
import { t } from "../../_i18n";
import { useEffect, useState } from "preact/hooks";
import "./DocumentsHistory.scss";

export default ({ documents, downloadDocument }) => {
  /** Variables **/
  const isMobile = isMobileAgent();

  /** States **/
  const [dataList, setDataList] = useState([]);

  /** Lifecycles **/
  useEffect(() => {
    setDataList(
      (documents || []).map((doc) => ({
        id: doc?.id || "-",
        name: doc?.name || "-",
        type: doc?.type?.name || "-",
        date: doc?.created_at ? formatDate(new Date(doc.created_at)) : "-",
        status: doc?.status || "-",
        errors: doc?.errors[0] || null,
      })),
    );
  }, [documents]);

  /** Methods **/
  const showBorder = (index = 0) =>
    dataList.length && dataList.length > 1 && index !== dataList.length - 1;

  const formatDate = (date) => {
    const parts = new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).formatToParts(date);

    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));

    const dayPeriod =
      map.dayPeriod?.startsWith("a") ? "AM" :
      map.dayPeriod?.startsWith("p") ? "PM" :
      "";

    return `${map.day} ${map.month} ${map.year}, ${map.hour}:${map.minute} ${dayPeriod}`;
  };

  const handleDownloadDocument = (id, name) => {
    downloadDocument(id, name);
  };

  /** Render **/
  return (
    <Fragment>
      <TableContainer
        className={`w-full rounded-t-lg border border-gray-200 bg-white text-sm ${dataList?.length && "rounded-b-lg"} `}
      >
        <TableHead className="bg-gray-100 font-bold">
          <TableCell className="w-32 border-b border-gray-200">#</TableCell>
          <TableCell className="border-b border-gray-200 text-left">
            {t("NOMBRE DE ARCHIVO")}
          </TableCell>
          <TableCell className="border-b border-gray-200 text-left">
            {t("TIPO DE DOCUMENTO")}
          </TableCell>
          <TableCell className="border-b border-gray-200 text-left">
            {t("FECHA DE ENVÍO")}
          </TableCell>
          <TableCell className="border-b border-gray-200 text-left">
            {t("ESTADO")}
          </TableCell>
        </TableHead>
        <TableBody>
          {dataList?.length
            ? dataList.map((data, index) => (
                <TableRow key={data.id}>
                  <TableCell
                    className={`w-32 border-gray-200 px-2 align-middle ${showBorder(index) ? "border-b" : ""}`}
                  >
                    {data.id}
                  </TableCell>
                  <TableCell
                    className={`min-w-40 border-gray-200 px-2 text-left align-middle ${showBorder(index) ? "border-b" : ""}`}
                  >
                    <a
                      href="#"
                      onClick={() => handleDownloadDocument(data.id, data.name)}
                      className="text-info-600 underline"
                    >
                      <span
                        className="block max-w-[180px] overflow-hidden text-ellipsis whitespace-nowrap"
                        title={data.name}
                      >
                        {data.name}
                      </span>
                    </a>
                  </TableCell>
                  <TableCell
                    className={`min-w-40 border-gray-200 px-2 text-left align-middle ${
                      showBorder(index) ? "border-b" : ""
                    }`}
                  >
                    <span
                      className="block max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap"
                      title={data.type}
                    >
                      {data.type}
                    </span>
                  </TableCell>

                  <TableCell
                    className={`min-w-44 border-gray-200 px-2 text-left align-middle ${showBorder(index) ? "border-b" : ""}`}
                  >
                    {data.date}
                  </TableCell>
                  <TableCell
                    className={`min-w-48 border-gray-200 px-2 text-left align-middle ${showBorder(index) ? "border-b" : ""}`}
                  >
                    {!isMobile ? (
                      <div
                        className={data.errors?.custom_error_message && 'checkbox-tooltip'}
                        data-tooltip={data.errors?.custom_error_message && data.errors?.custom_error_message}
                      >
                        <StateChip data={data.status} icon={data.errors?.custom_error_message && 'info-circle'}/>
                      </div>
                    ) : (
                      <Fragment>
                        <StateChip data={data.status} icon={data.errors?.custom_error_message && 'info-circle'} />
                        {data.errors?.custom_error_message &&
                          <span className="checkbox-disabled-msg">
                            ({data.errors?.custom_error_message})
                          </span>
                        }
                      </Fragment>
                    )}
                  </TableCell>
                </TableRow>
              ))
            : null}
        </TableBody>
      </TableContainer>
      {!dataList?.length && (
        <div className="-mt-[1px] rounded-b-lg border-b border-l border-r border-gray-200 bg-white p-4 text-center">
          {t("No hay documentos enviados.")}
        </div>
      )}
    </Fragment>
  );
};
